

























































































































































import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import {
  NotificationTabModel,
  TreatmentMonitoringApi,
  UnitModel,
} from "../../../apis";
import MyDateTimePickerMobile from "../mobile/common/MyDateTimePickerMobile.vue";
@Component({
  components: {MyDateTimePickerMobile},
})
export default class Alarm extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: () => {} }) unit: UnitModel;
  @Prop({ default: () => {} }) variables: { text: string; value: string }[];
  @Prop({ default: () => {} }) treatments: any[];

  searchForm = {
    variables: [],
    from: "",
    to: "",
    treatmentId: null,
  };
  alarms: NotificationTabModel[] = [];
  dataExport = [];
  page = 1;
  pageCount = 0;
  itemsPerPage = 10;

  get TREATMENTS() {
    return [{ value: null , text: this.$t("text.all") }, ...this.treatments];
  }

  get show() {
    this.searchForm.variables = this.variables.map((val) => val.value);
    this.searchForm.treatmentId = null;
    const today = new Date();
    this.searchForm.to = moment(today)
      .startOf("days")
      .format("YYYY-MM-DD HH:mm");
    this.searchForm.from = moment(today)
      .startOf("days")
      .add(-7, "days")
      .format("YYYY-MM-DD HH:mm");
    this.alarms = [];
    this.pageCount = 0;
    this.page = 1;

    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
columnsExport = [
    {
    label:this.$t("text.treatmentId"),
    field: "treatmentNumber"
    },
    {
    label:this.$t("text.date"),
    field: "date"
    },
    {
    label:this.$t("text.time"),
    field: "time"
    },
    {
    label:this.$t("text.alarmType"),
    field: "alarmType"
    },
];
  get HEADERS() {
    return [
      {
        text: this.$t("text.treatmentId"),
        value: "treatmentNumber",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.date"),
        value: "date",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.time"),
        value: "time",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.alarmType"),
        value: "type",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  async doSearch() {
    this.$util.showLoading();
    try {
      const rs =
        await new TreatmentMonitoringApi().getAlarmNotificationsByTreatment({
          unitId: this.unit.id,
          startDate: !this.searchForm.from
            ? ""
            : moment(this.searchForm.from, "YYYY-MM-DD HH:mm")
                .utc()
                .format("YYYY-MM-DD HH:mm"),
          endDate: !this.searchForm.to
            ? ""
            : moment(this.searchForm.to, "YYYY-MM-DD HH:mm")
                .utc()
                .format("YYYY-MM-DD HH:mm"),
          treatmentId: this.searchForm.treatmentId || "",
          language: "en",
          page: this.page,
          limit: this.itemsPerPage,
        });
      this.alarms = rs.data.data;
      this.pageCount = Math.floor(rs.data.count / this.itemsPerPage) + (rs.data.count % this.itemsPerPage > 0 ? 1 : 0);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doExport() {
    this.$util.showLoading();
    try {
      this.dataExport  = [];
      const rs =
        await new TreatmentMonitoringApi().getAlarmNotificationsByTreatment({
          unitId: this.unit.id,
          startDate: !this.searchForm.from
            ? ""
            : moment(this.searchForm.from, "YYYY-MM-DD HH:mm")
                .utc()
                .format("YYYY-MM-DD HH:mm"),
          endDate: !this.searchForm.to
            ? ""
            : moment(this.searchForm.to, "YYYY-MM-DD HH:mm")
                .utc()
                .format("YYYY-MM-DD HH:mm"),
          treatmentId: this.searchForm.treatmentId || "",
          language: "en",
          page:null,
          limit: null,
        });
      this.dataExport = rs.data.data.map(d=>{return {...d, 
          date: moment(d.DateTime).format("DD/MM/YYYY"),
          time: moment(d.DateTime).format("HH:mm")};}
          );
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const unitInfo = this.unit?  " [" + this.unit.location.locationName +'][' + this.unit.name+ "]": "";
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Alarm" + unitInfo,
        "xlsx",
        "ECO2 Web",
        this.dataExport,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }
}
